import { useEffect, useRef, useState } from 'react';

const values = [
  {
    title: 'Innovación',
    desc: 'Exploramos constantemente nuevas composiciones olfativas y tecnologías para anticipar las tendencias del mercado.',
    icon: 'ri-lightbulb-flash-line',
    color: '#D4A843',
  },
  {
    title: 'Excelencia',
    desc: 'Cada insumo es seleccionado bajo los más altos estándares de calidad, desde la importación hasta la entrega final al cliente.',
    icon: 'ri-award-line',
    color: '#C9953A',
  },
  {
    title: 'Pasión',
    desc: 'Amamos lo que hacemos. La distribución de perfumería es nuestro compromiso y cada entrega es una expresión de dedicación y profesionalismo.',
    icon: 'ri-heart-3-line',
    color: '#C8553D',
  },
  {
    title: 'Sostenibilidad',
    desc: 'Respetamos la naturaleza que nos inspira, adoptando prácticas responsables en cada etapa de nuestra cadena de suministro.',
    icon: 'ri-leaf-line',
    color: '#8BA888',
  },
];

function useVisible() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return { visible, ref };
}

export default function ValuesSection() {
  const { visible, ref } = useVisible();

  return (
    <section ref={ref} className="py-24 md:py-32 px-6 md:px-16 lg:px-24 bg-[#1a1a1a]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-4">Filosofía</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">Nuestros Valores</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {values.map((v, i) => (
            <div
              key={v.title}
              className={`text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="flex items-center justify-center w-14 h-14 mx-auto mb-8 border border-white/20 rounded-full">
                <i className={`${v.icon} text-xl`} style={{ color: v.color }} />
              </div>
              <h3 className="text-base font-bold text-white mb-4 tracking-wide uppercase">{v.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}